<template>
    <v-row v-if="shouldShow">
        <v-col cols="4">
            <strong class="font-weight-bold d-inline-block mb-2">
                {{ title }}
            </strong>
        </v-col>
        <v-col cols="8">
            <div
                v-for="module in modules"
                :key="getModuleKey(module)"
                class="pl-2 pb-2"
                v-show="getModuleQuantity(module) > 0"
            >
                <span v-if="shouldShowQuantity(module)">
                    {{ getModuleQuantity(module) }}x
                </span>
                {{ getModuleName(module) }}<br />
            </div>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: 'ModuleList',

    props: {
        modules: {
            type: Array,
            default: () => [],
        },

        title: {
            type: String,
            required: true,
        },

        moduleType: {
            type: String,
            default: 'fixed',
            validator: value => ['fixed', 'addon'].includes(value),
        },

        hideWhenEmpty: {
            type: Boolean,
            default: true,
        },
    },

    computed: {
        shouldShow() {
            return !this.hideWhenEmpty || this.modules.length > 0
        },
    },

    methods: {
        getModuleKey(module) {
            const id = module.id || module.module_id
            return `${this.moduleType}_${id}`
        },

        shouldShowQuantity(module) {
            return module.price_type !== 'flat'
        },

        getModuleQuantity(module) {
            if (this.moduleType === 'addon') {
                return module.add_amount != null
                    ? module.add_amount
                    : module.amount
            }
            return module.amount
        },

        getModuleName(module) {
            if (this.moduleType === 'fixed' && module.module) {
                return module.module.name
            }
            return module.name || (module.module && module.module.name) || ''
        },
    },
}
</script>
